export default "//file.bilionpass.com/japandx-web/0.0.1/static/num_01.e23e672e-c52912.svg";